import { Svg } from '../../../components/Svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SMSWhatsAppIcon = () => {
  return /*#__PURE__*/_jsxs(Svg, {
    $size: "32px",
    $color: "currentColor",
    $alignWithText: false,
    viewBox: "0 0 32 32",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M5 15C4.45333 15 4 15.4533 4 16V27C4 27.3867 4.22667 27.7333 4.56 27.9067C4.69333 27.9733 4.84 28 5 28C5.22667 28 5.44 27.92 5.62667 27.7867L10.3467 24H21C22.6533 24 24 22.6533 24 21V14C24 12.3467 22.6533 11 21 11H17C16.4533 11 16 11.4533 16 12C16 12.5467 16.4533 13 17 13H21C21.5467 13 22 13.4533 22 14V21C22 21.5467 21.5467 22 21 22H10C9.77333 22 9.54667 22.08 9.37333 22.2133L6 24.92V16C6 15.4533 5.54667 15 5 15Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M27 20C27.5467 20 28 19.5467 28 19V10C28 8.34667 26.6533 7 25 7H17C16.4533 7 16 7.45333 16 8C16 8.54667 16.4533 9 17 9H25C25.5467 9 26 9.45333 26 10V19C26 19.5467 26.4533 20 27 20Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M3 9H7V13C7 13.5467 7.45333 14 8 14C8.54667 14 9 13.5467 9 13V9H13C13.5467 9 14 8.54667 14 8C14 7.45333 13.5467 7 13 7H9V3C9 2.45333 8.54667 2 8 2C7.45333 2 7 2.45333 7 3V7H3C2.45333 7 2 7.45333 2 8C2 8.54667 2.45333 9 3 9Z",
      fill: "currentColor"
    })]
  });
};
export default SMSWhatsAppIcon;